module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="pdf-preview-wrap">\r\n    <div id="preview" class="pdf-wrap"></div>\r\n</div>';

}
return __p
}